import FundamentalSubNavigation from './FundamentalSubNavigation';
import { isDesktop } from '../../utils';
import { USER_INTERACTION_EVENTS } from '../../constants';

class TrimSubNavigation extends FundamentalSubNavigation {
  constructor(el) {
    super(el);
    this.init();

    this.classes = {
      ...this.classes,
      pinSubNavTrim: 'pin-sub-nav-trim',
      trimPinDesktop: 'trim-pin-desktop',
    };
    this.positionFlag = 0;
    this.dom = {
      ...this.dom,
      $smallText: this.$el.find('.sub-nav-small-text'),
      $jsGroupBottomContent: this.$el.find('.js-group-content-bottom'),
    };

    // state manage pin subnav for Trim Template
    this.trimSubNavPinned = false;
    this.numberScroll = 16;
  }

  init() {
    super.init();
    this.dom.$body.addClass('trim-template');
    this.initPinSubNavAction();
    this.addListeners();
  }

  initPinSubNavAction() {
    const initFunc = () => {
      if (isDesktop() && !this.isSubNavTopOnHeaderDesktop) {
        this.dom.$body.addClass(this.classes.trimPinDesktop);
        this.isSubNavTopOnHeaderDesktop = true;
        this.dom.$header.after(this.dom.$subNav);
      }
    };
    $(window).on(USER_INTERACTION_EVENTS, () => {
      initFunc();
    });
    window.scrollAgent.scrollEvent((args) => {
      const scrollY = args.scroll.y.toFixed(2);
      if (this.positionFlag !== scrollY) {
        this.positionFlag = scrollY;
        initFunc();
        if (isDesktop()) {
          this.pinSubNav();
        }
      }
    });
  }

  addListeners() {
    super.addListeners();
    this.customScrollEventTrimPage();
  }

  /* event Scroll page */
  customScrollEventTrimPage() {
    $(window).on('scroll', () => {
      if (!isDesktop()) {
        this.pinSubNav();

        if (this.customScrollTop === 0) {
          this.dom.$body.removeClass(this.classes.showScrollHeader).removeClass(this.classes.hideScrollHeader);
          this.hideSubNav();
        }
      }
    });
  }

  pinSubNav() {
    const timeoutAnimateFunction = () => {
      setTimeout(() => {
        this.dom.$smallText.css('display', 'block');
        const heightSubNav = this.dom.$smallText.height();
        if (heightSubNav > 42) {
          this.dom.$jsGroupBottomContent.css('top', -((heightSubNav - 42) / 2) + 2);
        }
      }, 200);
    };
    if (isDesktop()) {
      if (this.dom.$smallText.length) {
        if (this.customScrollTop > this.numberScroll && !this.trimSubNavPinned) {
          this.trimSubNavPinned = true;
          this.dom.$subNav.addClass(this.classes.pinSubNavTrim);
          this.dom.$smallText.stop();
          timeoutAnimateFunction();
        }
        if (this.customScrollTop <= this.numberScroll && this.trimSubNavPinned) {
          this.trimSubNavPinned = false;
          this.dom.$subNav.removeClass(this.classes.pinSubNavTrim);
          this.dom.$smallText.css('display', '');
          this.dom.$jsGroupBottomContent.css('top', '');
        }
      }
      this.resetUnpinGroupBottomAboveFooterMobile();
    } else {
      this.dom.$smallText.removeClass('xl:hidden');
      this.dom.$jsGroupBottomContent.css('top', '');
      this.trimSubNavPinned = false;
      this.unpinGroupBottomAboveFooterMobile();
    }
  }
}
export default TrimSubNavigation;